/**
 * KOV Premium Theme Enhancements JS
 * Lightweight storefront interactions only.
 */
document.addEventListener('DOMContentLoaded', () => {
  'use strict';

  // 2026-09-30 accessibility: the product quantity box had no usable label (its <label> is
  // visually hidden by the theme, so Lighthouse/screen readers get no name). Give every
  // quantity input an explicit accessible name without changing the visible design.
  document.querySelectorAll('input[name="quantity"]').forEach((input) => {
    if (!input.getAttribute('aria-label')) input.setAttribute('aria-label', 'Quantity');
  });

  const header = document.querySelector('.header-wrapper');
  if (!header) return;

  let ticking = false;
  let lastScrolled = null;

  const updateHeader = () => {
    ticking = false;
    const scrolled = window.scrollY > 20;
    if (scrolled === lastScrolled) return;
    lastScrolled = scrolled;
    header.classList.toggle('kov-header-scrolled', scrolled);
  };

  const scheduleHeaderUpdate = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(updateHeader);
  };

  window.addEventListener('scroll', scheduleHeaderUpdate, { passive: true });
  scheduleHeaderUpdate();
});
